import { createContext } from 'react'

const NotifyContext = createContext()
const UserContext = createContext({})
const SettingsContext = createContext()
const PdaContext = createContext()

NotifyContext.displayName = 'NotifyContext';
UserContext.displayName = 'UserContext';
SettingsContext.displayName = 'SettingsContext';
PdaContext.displayName = 'PdaContext';

export { NotifyContext, UserContext, SettingsContext, PdaContext }
